export const CloseIcon = ({ width = 32, height = 32 }) => (
  <svg
    className="svg-icon icon-close"
    focusable="false"
    tabIndex={-1}
    aria-hidden="true"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      aria-hidden="true"
      focusable="false"
      tabIndex={-1}
      className="primary-path"
      d="M22.4 9.6C21.88 9.08 21.04 9.08 20.52 9.6L16 14.12L11.48 9.6C10.96 9.08 10.12 9.08 9.6 9.6C9.08 10.12 9.08 10.96 9.6 11.48L14.12 16L9.6 20.52C9.08 21.04 9.08 21.88 9.6 22.4C10.12 22.92 10.96 22.92 11.48 22.4L16 17.88L20.52 22.4C21.04 22.92 21.88 22.92 22.4 22.4C22.92 21.88 22.92 21.04 22.4 20.52L17.88 16L22.4 11.48C22.92 10.96 22.92 10.12 22.4 9.6Z"
      fill="#3F4447"
    />
  </svg>
);
